import { render, staticRenderFns } from "./CommessaGruppoFasi.vue?vue&type=template&id=007f8b1e&scoped=true&"
import script from "./CommessaGruppoFasi.vue?vue&type=script&lang=js&"
export * from "./CommessaGruppoFasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f8b1e",
  null
  
)

export default component.exports